import React, {Component} from 'react';
import config from '../../config';
import zoomerActions from '../../actions/zoomer';
import Icon from './icon';

export default class SIMZoomerControls extends Component {

  static resetZoom () {
    zoomerActions.emit(zoomerActions.EVENTS.RESET);
  }

  getZoomCallback (direction) {
    return function (e) {
      e.preventDefault();
      e.stopPropagation();
      zoomerActions.emit(zoomerActions.EVENTS.ZOOM, direction);
    }.bind(this);
  }

  render () {
    if (config.system.hideNavigation) {
      return false;
    }

    return (
      <div data-component="zoomer__controls" className="zoomer__controls">
        <button className="zoomer__control--reset" onClick={SIMZoomerControls.resetZoom}><Icon type="reset" /></button>
        <button className="zoomer__control--zoomin" onClick={this.getZoomCallback(1)}><Icon type="plus" /></button>
        <button className="zoomer__control--zoomout" onClick={this.getZoomCallback(-1)}><Icon type="minus" /></button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/zoomer/controls.jsx